<template>
  <div class="filter-check">
    <template
      v-for="(value, key) in filters"
      :key="key"
    >
      <FilterCheckbox
        :label="value.label"
        :icons="value.icons"
        @update:model-value="
          (e) => {
            changeTypeFilter(key, e)
            changeSummary(value.label, e)
          }
        "
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import FilterCheckbox from '@/components/setup/FilterCheckbox.vue'
import { CommonCheckFilterType } from '@/types/filter'

defineProps<{
  filters: CommonCheckFilterType
}>()

const filtersToEmit = ref<Record<string, boolean>>({})
const changeTypeFilter = (key: string, e: boolean) => {
  filtersToEmit.value[key] = e

  emits('updated', filtersToEmit.value)
}

const summary = ref<string[]>([])
const changeSummary = (label: string, e: boolean) => {
  if (e) {
    summary.value.push(label)
  } else {
    const index = summary.value.indexOf(label)

    if (index > -1) summary.value.splice(index, 1)
  }

  emits('summary', summary.value.join(', '))
}

const emits = defineEmits<{
  (e: 'updated', val: typeof filtersToEmit.value): void
  (e: 'summary', val: string): void
}>()
</script>

<style lang="scss">
.filter-check {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
</style>
